import React from "react";
import PropTypes from "prop-types";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  TablePagination as MuiTablePagination,
  IconButton,
} from "@material-ui/core";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useTranslation } from "react-i18next";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

const TablePaginationActions = (props) => {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage, refreshData, config } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const handleRefreshClick = () => {
    refreshData(config);
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleRefreshClick}
        disabled={false}
        aria-label="refresh"
      >
        <RefreshIcon />
      </IconButton>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  refreshData: PropTypes.func,
  config: PropTypes.object,
};

const TablePagination = (props) => {
  const { t } = useTranslation();
  const {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    refreshData,
    config,
    totalRecords,
    disableLabelDisplayedRows,
  } = props;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <MuiTablePagination
        style={{
          display: "flex",
          justifyContent: "left",
          width: "100%",
          textAlign: "left",
          backgroundColor: "#fff",
        }}
        labelRowsPerPage={t("Rows per page")}
        
        rowsPerPageOptions={[10, 25, 50, 100]}
        colSpan={1}
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        SelectProps={{
          inputProps: { "aria-label": "Rows per page" },
          native: true,
        }}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={() => (
          <TablePaginationActions
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            refreshData={refreshData}
            config={config}
          />
        )}
        labelDisplayedRows={
          disableLabelDisplayedRows 
            ? () => {}
            : ({ from, to, count }) => {
                return from + "-" + to + " of " + count + " " + t("items");
              }
        }
      />
    </>
  );
};

TablePagination.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
  refreshData: PropTypes.func,
  config: PropTypes.object,
  totalRecords: PropTypes.number,
  disableLabelDisplayedRows: PropTypes.bool,
};

export default TablePagination;
